export const carouselModal = () => {
    return {
        main: null,
        bg: null,

        init() {
            const isMobile = window.innerWidth < 768;
            this.main = this.$refs.main;
            this.bg = this.$refs.bg.swiper;

            const swiperParams = {
                pagination: {
                    el: isMobile
                        ? ".card-modal-carousel-pagination--mobile"
                        : ".card-modal-carousel-pagination",
                    type: "fraction",
                },
                on: {
                    slideChange: () => {
                        this.bg.slideTo(this.main.swiper?.realIndex)
                    }
                }
            };

            Object.assign(this.main, swiperParams);
            this.main.initialize();
        },

    }
}